import { Client, query } from 'faunadb';
import { configure, base } from 'airtable';
import '@fortawesome/fontawesome-free/css/all.css';
import $ from 'jquery';


//Authenticate FaunaDB
var client = new Client({ secret: 'fnADsyd4LJACFETeSz-1beKOHcmUcdXPGEqDi2U7' })

//Authenticate Airtable
var airtableconfig = configure({
  endpointUrl: 'https://api.airtable.com',
  apiKey: 'keyAIHNaGglb4Vudk'
});

//Specify which Airtable base
var atbase = base('appFeV7DNz5hNq9dl');


//🌎 variables
var allMapObjects = [];
var recentlyUsedArray = [];
var currentMap = {
  id: null,
  imgURL: null,
  Source: null,
  index: null
};



//Use the Airtable JS API select method to grab the map ID & picture URL from Airtable
//and store them for each Airtable record in an array called 'allMaps'
atbase('media').select({
  view: 'published'
}).firstPage(function(err, records) {
  if (err) { console.error(err); return; }
  records.forEach(function(record) {
    var newMap = { mapID: record.get("Attachments")[0].id, mapURL: record.get("Attachments")[0].url, allMapsource: record.get("Source") };
    allMapObjects.push(newMap);
  });
});


//Create a randomly-generated number to use as index to the allMaps array,
//but before picking that item in the allMaps array, check first against
//a new array called "recentlyUsed", to see if we have shown it already
function mapRandomizer(){
  var randomIndex = Math.floor(Math.random() * allMapObjects.length);
  //Increase this number 👇 if you want the to-skip memory sequence to be longer 
  if (recentlyUsedArray.length > 10){
    recentlyUsedArray.shift();
  }
  if (recentlyUsedArray.includes(randomIndex)){
    do{
      randomIndex = Math.floor(Math.random() * allMapObjects.length);
      recentlyUsedArray.push(randomIndex);
      addMap(randomIndex);
      break;
    } while (recentlyUsedArray.includes(randomIndex));
  } else{
    recentlyUsedArray.push(randomIndex);
    addMap(randomIndex);
  }
}

//Add the map to the website!!
function addMap(index) {
  var map = allMapObjects[index];
  currentMap.id = map.mapID;
  currentMap.imgURL = map.mapURL;
  currentMap.imgSource = map.allMapsource;
  $("#map").attr("src", currentMap.imgURL);
  $("#source-answer").html("");
  $("#source-answer").append(currentMap.imgSource);
}


//Main function to get things going
function initialize(){
  //Starts off by calling the randomizer, which then calls addMap()
  //addMap() is the function that takes all the loaded values
  //accessed and manipulated by mapRandomizer() and adds them to a globally
  //accessible object called currentMap, to be used later in lots of places. 
  mapRandomizer();
}


//Call initialize when the page loads to get the first map
$(document).ready(function() {
 setTimeout(initialize, 1000)
});


//Search for all the maps in the user votes database that matches the id of the current map
//Then call the addVotes() function, which updates the database with the new vote
function getMapStats(){
  client.query(
		query.Map(query.Paginate(query.Match(query.Index('votes-by-id'), currentMap.id)),query.Lambda('X', query.Get(query.Var('X'))))
	).then((d) => {
    addVotes(d);
	}).catch((e)=>{console.log(e);});
}

//If a record for the current map exists already, append the new vote value to that record 
//If a record doesn't exist yet, create one
function addVotes (d){
  //get the position of the input slider 👇
  var newVote = Number(document.getElementById("vote-slider").value);
  //See if a record already exists 
  if (d.data.length === 0 ){
    //If not, make one 👇
    client.query(
      query.Create(
        query.Collection("map-votes"), { 
          data: {
            'id': currentMap.id, 
            'votes': [newVote],
          }
        }
      )
    ).then((d) => {
      showAverage(d.data.votes);
    })
  } else if (d.data.length === 1){
    //If votes have already been logged for this map, 
    //merge those with the new vote value 👇
    client.query(
      query.Merge(
        d.data[0].data,
        { id: currentMap.id, votes: [newVote]},
        query.Lambda(['key', 'a', 'b'],
          query.If(
            query.Equals(query.Var('key'), 'votes'),
            query.Append(query.Var('b'),query.Var('a')),
            query.Var('b'),
          )
        )
      )
    ).then((d) => {
      //Add the merged object as a new document to the collection
      client.query(query.Create(query.Collection("map-votes"), { data: d}))
      .then((d) => {
        client.query(query.Mean(d.data.votes))
        .then((d) => {
          showAverage(d);
        })
      })
    })
    //Kill the outdated record in the collection
    client.query(query.Delete(query.Ref(query.Collection("map-votes"), d.data[0].ref.value.id)))
  }
}


//Appends average values to various html elements on the results page 👇
function showAverage(avg){
  console.log(avg);
  document.getElementById('result-arrow').innerHTML = '<i class="fas fa-long-arrow-alt-up"></i><br><h2 class = "score-label">AVERAGE<br>VOTE</h2>';
  $('div#result-arrow').css('left', avg * 10 + "%");
  $("#next-map").click(() => {
    $("resut-arrow").empty();
  });
  resultsAvailable();
}


//change the display and record values upon submit
function submit(){
  gettingResults();
  getMapStats();
}


//DISPLAY STUFF & EVENT HANDLING 👇

//Function to hide the voting interface and show the results page
function gettingResults(){
  $("#loader-container").show();
}

function resultsAvailable(){
  $("#user-controls-container").hide();
  $("#map").hide();
  $("#map").attr("src", " ");
  $("#loader-container").hide();
  $("#map-container").hide();
  $("#results-page").show();
}



//Function to hide the results page and show another map
function voteAgain(){
  $("#results-page").hide();
  $("#map-container").show();
  $("#user-controls-container").show();
  document.getElementById("vote-slider").value = 5;
  initialize();
  $("#map").show();
}

//Call initialize whenever someone clicks skip to get a new map
$("#skip-button").click(initialize);

//Upon submit, hide the voting interface and show the results page
$("#submit-button").click(submit);

//Upon submit, hide the results page and show the voting interface
$("#next-map").click(voteAgain);
